import { spawnGetApiFunction, spawnUpdateApiFunction, type ApiResourceConfig } from "@/utils/api";

const table = "workspace_profiles";
const query = "*";

export const apiConfigWorkspaceProfiles: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: ["name", "description", "website"],
  sortables: ["created_at", "updated_at", "name"],
};

export const getWorkspaceProfile = spawnGetApiFunction({ table, query });
export const updateWorkspaceProfile = spawnUpdateApiFunction({ table, query });
